import React, { Component } from "react";
import PropTypes from "prop-types";
import { GithubPicker } from "react-color";
import Popover from "module-common/Popover";

export default class PickerColor extends Component {
  static propTypes = {
    onColorSelected: PropTypes.func
  };

  render() {
    const { children, ...rest } = this.props;
    const colors = ["#900540", "#73CE5F", "#4BA7BC", "#EA9357", "#52CBD1", "#B0B5B2", "#FC92AE", "#E55E5E", "#383838", "#916199", "#E88A00"];
    return (
      <Popover
        {...rest}
        show="click"
        hide="click"
        position="bottom"
        content={
          <GithubPicker triangle="hide" onChangeComplete={this.onChangeColor} colors={colors} />
        }
      >
        {children}
      </Popover>
    );
  }

  onChangeColor = color => {
    const onColorSelected = this.props.onColorSelected;
    if (onColorSelected) onColorSelected(color.hex);
  };
}



// WEBPACK FOOTER //
// ./src/module-common/PickerColor.js